import React from 'react';
import PropTypes from 'prop-types';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import { withTranslation } from 'react-i18next';

const Footer = ({ t, i18n, domain }) => {
    return (
        <footer className="footer">
            <Grid
                container
                spacing={2}
                direction="row"
                justifyContent="center"
                alignItems="center"
            >
                <Grid item xs={12} sm={12} align={'center'}>
                    <Link
                        color="secondary"
                        className={'footer-link'}
                        href={`/${i18n.language}/about`}
                        title={t('aboutus', { domain })}
                    >
                        {t('aboutus', { domain })}
                    </Link>{' '}|{' '}
                    <Link
                        color="secondary"
                        className={'footer-link'}
                        href={`/${i18n.language}/privacypolicy`}
                        title={t('privacyPolicyLink')}
                    >
                        {t('privacyPolicyLink')}
                    </Link>
                    {domain === 'forecast.lv' && <>
                        {' '}|{' '}
                        <Link
                            color="secondary"
                            className={'footer-link'}
                            href={`https://weather5days.com`}
                            title={'weather5days.com'}
                            target={'_blank'}
                        >
                            weather5days.com
                        </Link>
                    </>
                    }
                </Grid>
                {/*     <Grid item xs={6} sm={6} />*/}
            </Grid>
        </footer>
    );
};

Footer.propTypes = {
    data: PropTypes.array,
};

Footer.defaultProps = {
    data: [],
};

export default withTranslation('translations')(Footer);

